import { useState, useEffect } from 'react';
import { getToasts, subscribeToast, dismissToast } from '../lib/toast';
import { CheckCircle, AlertCircle, X } from 'lucide-react';

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState(getToasts());

  useEffect(() => {
    return subscribeToast(() => setToasts([...getToasts()]));
  }, []);

  if (toasts.length === 0) return null;

  const icons: Record<string, React.ReactNode> = {
    success: <CheckCircle className="w-5 h-5 text-green-500" />,
    error: <AlertCircle className="w-5 h-5 text-red-500" />,
    warning: <AlertCircle className="w-5 h-5 text-yellow-500" />,
    info: <AlertCircle className="w-5 h-5 text-blue-500" />,
  };

  return (
    <div className="fixed top-4 right-4 z-[10000] flex flex-col gap-2" role="status" aria-live="polite">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className="flex items-center gap-3 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-lg rounded-xl px-4 py-3 min-w-[300px] max-w-md animate-fade-in-up"
        >
          {icons[toast.type]}
          <p className="flex-1 text-sm text-slate-900 dark:text-slate-50">{toast.message}</p>
          <button
            onClick={() => dismissToast(toast.id)}
            className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-50 transition-colors"
            aria-label="Fechar notificacao"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
